
import { defineComponent } from "vue";
//   import { RouterLink, useRouter } from "vue-router";
//   import { useStore } from "vuex";
import axios from "axios";

interface CrossObjective {
  id: number;
  title: string;
  weight: number;
  created_at: string;
}

export default defineComponent({
  name: "OKRCheckerSideBar",
  data() {
    return {
      crossObjectives: [] as CrossObjective[],
      newObjective: "",
      newWeight: null,
    };
  },
  async created() {
    const response = await axios.get("/api/cross_objectives"); // replace with your API endpoint
    this.crossObjectives = response.data as CrossObjective[];
  },
  methods: {
    async deleteCrossObjective(id: number) {
      const response = await axios.post(`/api/delete_cross_objective/${id}`); // replace with your API endpoint
      if (response.data.success) {
        this.crossObjectives = this.crossObjectives.filter(
          (objective) => objective.id !== id
        );
      }
    },
    async addNewCrossObjective() {
      const response = await axios.post("/api/new_cross_objective", {
        objective: this.newObjective,
        weight: this.newWeight,
      }); // replace with your API endpoint
      if (response.data.success) {
        this.crossObjectives.push(response.data.newObjective);
        this.newObjective = "";
        this.newWeight = null;
      }
    },
  },
});
